import WeAreClosed from './WeAreClosed';
export default WeAreClosed;